
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");
import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import AddAliasForm from '../AddAliasForm.vue';
import AddRepresentativeForm from '../AddRepresentativeForm.vue';
import {getPartyTitles, getFullName} from "../PartyTitles"

import { supremeCourtPartiesJsonInfoType } from '@/types/Information/json';

import sortStyleOfProceeding from './util/sortStyleOfProceeding';
import { form1DataInfoType, lookupsInfoType, form1PartiesInfoType, form1PartiesStatesInfoType, manualSopInfoType, aliasInfoType, representativeInfoType } from '@/types/Information/Form1';

@Component({
    components:{        
        AddAliasForm,
        AddRepresentativeForm        
    },
    directives:{
        sortStyleOfProceeding
    }
})
export default class styleOfProceedingsActions extends Vue {     

    @form1State.State
    public form1Info: form1DataInfoType;    

    @commonState.State
    public userName!: string;

    @commonState.State
    public lookups!: lookupsInfoType;    

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    @form1State.State
    public form1ManualSopOrder!: number[];

    @form1State.Action
    public UpdateForm1ManualSopOrder!: (newform1ManualSopOrder: number[]) => void

    partyTypeOptions = [
        {text: 'an individual', value: false},
        {text: 'an organization', value: true}
    ];

    aliasFields = [
        {
            key:'nameType',          
            label:'Alias Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Alias Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    sopFields = [
        {
            key:'partyName',          
            label:'',                
                      
            sortable:false            
        },
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    representativeFields = [
        {
            key:'repType',          
            label:'Representative Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Representative Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    styleOfProceedingOptions = [
        {text: 'And', value: 'And'},
        {text: 'Between', value: 'Between'},
        {text: 'Re', value: 'Re'},
        {text: 'In The Matter Of', value: 'In The Matter Of'}
    ];

      
    displayWarning = true;

    AddNewAliasForm = false;       
    addAliasFormColor = 'court';
    latestEditAliasData;
    isEditAliasOpen = false;

    AddNewRepresentativeForm = false; 
    addRepresentativeFormColor = 'court';
    latestEditRepresentativeData;
    isEditRepresentativeOpen = false;
    updated = 0;
    updatedPartyInfo = 0;
    
    partyDataReady = false;

    //partiesList: form1PartiesInfoType[] = [];  
    party = {} as form1PartiesInfoType;    
    partyToEdit = {} as form1PartiesInfoType;
    updateTable = 0;
    showPartyWindow = false;
    showConfirmDeleteParty = false;
    showConfirmEditStyleOfProceeding = false;
    showEditStyleOfProceedingWindow = false;
    styleOfProceedingDataReady = false;
    enableAddParty = false;
    enableEditParty = false;
    isCreate = false;
    showConfirmEditParties = false;

    respondentSolicitors: string[] = [];
    respondents: string[] = [];
    styleOfProceedingsInfo = {} as form1DataInfoType;
    form1PartiesStates = {} as form1PartiesStatesInfoType; 
    editStyleOfProceedingsEnabled = true;   
    noRolePartyManualSop: manualSopInfoType[] = [];

    referenceNumber = '';    
    updatedInfo = 0;
    dataReady = false;
   

    mounted() { 

        this.dataReady = false;
        this.styleOfProceedingsInfo = this.form1Info;
        this.form1PartiesStates = {} as form1PartiesStatesInfoType;
        this.dataReady = true;
    }    

    public addParties(){       
        this.party = {} as supremeCourtPartiesJsonInfoType;
        this.enableAddParty = false;
        this.isCreate = true;
        this.showPartyWindow = true;
        this.partyDataReady = false; 
        this.displayWarning = true;        
        this.party.aliases = [];
        this.party.legalReps = [];
        this.partyDataReady = true;
    }

    public saveNewParty(){

        if (this.checkPartyStates()){
            const styleOfProceedings = this.form1Info;
            const partiesList = this.form1Info.parties;
            const partiesListIds = partiesList.map(party => party.ceisPartyId)
            const ceisPartyId = partiesListIds.length>0? Math.max(...partiesListIds)+1 : 1

            if (this.party.isOrganization){
                this.party.surname = null;
                this.party.firstGivenName = null;
                this.party.secondGivenName = null;
                this.party.thirdGivenName = null;
                this.party.fullName = getFullName(this.party);
                this.party.ceisPartyId = ceisPartyId;

            } else {
                if (!this.party.secondGivenName) this.party.secondGivenName = null;
                if (!this.party.thirdGivenName)this.party.thirdGivenName = null;
                this.party.organizationName = null;
                this.party.fullName = getFullName(this.party); 
                this.party.ceisPartyId = ceisPartyId;              
            }           

            this.party.title = getPartyTitles(this.party, '</br>', false);        
            partiesList.push(this.party);       
            styleOfProceedings.parties = partiesList;
            this.UpdateForm1Info(styleOfProceedings);        
            this.showPartyWindow = false;
            Vue.nextTick(()=> {
                this.updateResults();
            });           

        }        
    }

    public editParties(){
        this.party = {} as supremeCourtPartiesJsonInfoType;
        this.partyToEdit = {} as supremeCourtPartiesJsonInfoType;
        this.enableEditParty = false;
        this.isCreate = false;
        this.showPartyWindow = true;
        this.partyDataReady = false; 
        this.displayWarning = true;
    }

    public saveParty(){

        if (this.checkPartyStates()){

            const styleOfProceedings = this.form1Info;

            this.party.fullName = getFullName(this.party);

            this.party.title = getPartyTitles(this.party, '</br>', false);

            if (this.party.appealRole) {
                this.party.appealRole = ''                                                  
            }  

            // styleOfProceedings.respondents = [];
            // styleOfProceedings.appellants = [];
            // for(const party  of this.form1Info.parties){

            //     if(party.appealRole == 'Appellant')        
            //         styleOfProceedings.appellants.push(party);
            //     if(party.appealRole ==  'Respondent')        
            //         styleOfProceedings.respondents.push(party);
            // }

            this.UpdateForm1Info(styleOfProceedings);        
            this.showPartyWindow = false;
            Vue.nextTick(()=> {
                this.updateResults();
            });
        }
       
    }

    public checkPartyStates(){

        let stateCheck = true;
        if (this.party.isOrganization){

            this.form1PartiesStates.organizationName = !(this.party.organizationName)? false : null;           
            this.form1PartiesStates.lowerCourtRole = !(this.party.lowerCourtRole)? false : null;

        } else {
            this.form1PartiesStates.surname = !(this.party.surname)? false : null;
            this.form1PartiesStates.firstGivenName = !(this.party.firstGivenName)? false : null;
            this.form1PartiesStates.lowerCourtRole = !(this.party.lowerCourtRole)? false : null;
        }
        
        this.updatedPartyInfo ++;

        for(const field of Object.keys(this.form1PartiesStates)){
            if(this.form1PartiesStates[field]==false)
                stateCheck = false;
        }

        return stateCheck;            
    }

    public editStyleOfProceeding(){ 

        const styleOfProceedings = this.form1Info;

        if (styleOfProceedings.respondents && 
            styleOfProceedings.respondents.length > 0 &&
            styleOfProceedings.appellants && 
            styleOfProceedings.appellants.length > 0 ){
                this.showConfirmEditStyleOfProceeding = true;
                this.editStyleOfProceedingsEnabled = true;
            } else {
                this.editStyleOfProceedingsEnabled = false;
            }        
    }

    public enableAdd(){
        this.displayWarning = false;
        this.enableAddParty = true;
    }

    public enableEdit(){
        this.displayWarning = false;
        this.enableEditParty = true;
        console.log(this.partyToEdit)
        this.party = this.partyToEdit;
        this.partyDataReady = true;
    }

    public addNewAlias(){
        if(this.isEditAliasOpen){            
            this.addAliasFormColor = 'danger'
        }else{
            this.AddNewAliasForm = true;            
        }
    }

    public addNewRepresentative(){
        if(this.isEditRepresentativeOpen){            
            this.addRepresentativeFormColor = 'danger'
        }else{
            this.AddNewRepresentativeForm = true;            
        }
    }

    public modifyAliasList(isCreateAlias: boolean, newAlias: aliasInfoType, index: number){        

        if (isCreateAlias){           
            this.party.aliases.push(newAlias)
            this.closeAliasForm();
        } else {           
            this.party.aliases[index].nameType = newAlias.nameType;
            this.party.aliases[index].name = newAlias.name;           
            this.closeAliasForm();
        }
        this.updated ++;
        
    }

    public removeAlias(data){        
        this.party.aliases.splice(data.index,1);
        this.updated ++;        
    }

    public modifyRepresentativeList(isCreateRep: boolean, newRepresentative: representativeInfoType, index: number){       

        if (isCreateRep){           
            this.party.legalReps.push(newRepresentative)
            this.closeRepresentativeForm();
        } else {           
            this.party.legalReps[index].repType = newRepresentative.repType;
            this.party.legalReps[index].name = newRepresentative.name;           
            this.closeRepresentativeForm();
        }
        this.updated ++;        
    }

    public removeRepresentative(data){
        this.party.legalReps.splice(data.index,1);
        this.updated ++;
    }

    public closeAliasForm() {                     
        this.AddNewAliasForm= false; 
        this.addAliasFormColor = 'court'
        if(this.isEditAliasOpen){
            this.latestEditAliasData.toggleDetails();
            this.isEditAliasOpen = false;
        } 
    }

    public closeRepresentativeForm() {                     
        this.AddNewRepresentativeForm= false; 
        this.addRepresentativeFormColor = 'court'
        if(this.isEditRepresentativeOpen){
            this.latestEditRepresentativeData.toggleDetails();
            this.isEditRepresentativeOpen = false;
        } 
    }

    public editAlias(data) {
        if(this.AddNewAliasForm || this.isEditAliasOpen){            
            this.addAliasFormColor = 'danger';                     
        }else if(!this.isEditAliasOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAliasOpen = true;
            this.latestEditAliasData = data            
        }   
    }

    public editRepresentative(data) {
        if(this.AddNewRepresentativeForm || this.isEditRepresentativeOpen){            
            this.addRepresentativeFormColor = 'danger';                     
        }else if(!this.isEditRepresentativeOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditRepresentativeOpen = true;
            this.latestEditRepresentativeData = data;            
        }   
    }    

    public confirmDeleteParty(){        
        this.showConfirmDeleteParty = true;
    }
    
    public cancelPartyDeletion() {
        this.showConfirmDeleteParty = false;
    }

    public deleteParty(){
        const styleOfProceedings = this.form1Info
        const partiesList = this.form1Info.parties;
        this.showConfirmDeleteParty = false;
        const index = partiesList.findIndex(originalParty => originalParty.ceisPartyId == this.party.ceisPartyId)                         
        partiesList.splice(index, 1);       
        styleOfProceedings.parties = partiesList;
        this.UpdateForm1Info(styleOfProceedings);        
        this.showPartyWindow = false;
        Vue.nextTick(()=> {
            this.updateResults();
        });
    }

    public confirmEditStyleOfProceedings(){ 

        const styleOfProceedings = this.form1Info;

        this.styleOfProceedingDataReady = false;
        this.showEditStyleOfProceedingWindow = true;       
        this.showConfirmEditStyleOfProceeding = false;    
        
        this.noRolePartyManualSop = [];
        this.loadSopInfo(styleOfProceedings.appellants);
        this.loadSopInfo(styleOfProceedings.respondents); 

        styleOfProceedings.manualSop = styleOfProceedings.manualSop.concat(this.noRolePartyManualSop)        

        this.UpdateForm1ManualSopOrder([...Array(styleOfProceedings.manualSop.length).keys()])

        this.UpdateForm1Info(styleOfProceedings);

        this.styleOfProceedingsInfo = JSON.parse(JSON.stringify(this.form1Info));
        this.styleOfProceedingDataReady = true;
    }


    public loadSopInfo(partiesInfo: form1PartiesInfoType[]){        

        if (this.styleOfProceedingsInfo.manualSop && this.styleOfProceedingsInfo.manualSop.length > 0){

            for (const party of partiesInfo){

                const currentSop = this.styleOfProceedingsInfo.manualSop;
                const identicalIndex = currentSop.findIndex(sop => sop.partyName.split('; ').includes(this.getPartyDisplayName(party)));

                if (identicalIndex != -1){
                    if (currentSop[identicalIndex].lowerCourtRole == party.lowerCourtRole && currentSop[identicalIndex].appealRole == party.appealRole){
                        continue;
                    } else {
                        const partyNames = currentSop[identicalIndex].partyName.split('; ')
                        const nameIndex = partyNames.findIndex(name => name == this.getPartyDisplayName(party))
                        this.styleOfProceedingsInfo.manualSop[identicalIndex].partyName = partyNames.splice(nameIndex, 1).join('; ');
                        this.prePopulateSop(party);
                    }
                } else {
                    const index = currentSop.findIndex(sop => sop.lowerCourtRole == party.lowerCourtRole && sop.appealRole == party.appealRole);
                    if (index != -1){
                        const partyNames = this.styleOfProceedingsInfo.manualSop[index].partyName.split('; ')
                        partyNames.push(this.getPartyDisplayName(party))
                        this.styleOfProceedingsInfo.manualSop[index].partyName = partyNames.join('; ')
                        this.styleOfProceedingsInfo.manualSop[index].plural = true;
                    } else {                        
                        this.prePopulateSop(party);
                    }
                }
            }

        } else {

            this.styleOfProceedingsInfo.manualSop = [];
            for (const party of partiesInfo){
                this.prePopulateSop(party);
            }

        }       

    }

    public getPartyDisplayName(partyInfo: form1PartiesInfoType){
        let title = '';
        if (partyInfo.legalReps.length == 0 && partyInfo.aliases.length == 0){            
            title = partyInfo.fullName;
        } else {

            const repTitle = [];
            for (const legalRep of partyInfo.legalReps){                
                const repFormat = this.lookups.legalRepFormatters[legalRep.repType].replace('{0}', legalRep.name).replace('{1}', partyInfo.fullName);
                repTitle.push(repFormat);
            }
            
            const aliasTitle = [];
            for (const alias of partyInfo.aliases){                    
                aliasTitle.push(alias.nameType + ' ' + alias.name);
            }
           
            const repText = repTitle.length?repTitle.join('or '): '';
            const aliasText = aliasTitle.length?aliasTitle.join(', '): '';            
            title = (repText?(repText + ", "):'') + aliasText;
        }

        return title;
    }

    public prePopulateSop(partyInfo: form1PartiesInfoType){

        const styleOfProceedings = this.form1Info;

        let sop = {} as manualSopInfoType;            
        sop.plural = false;
        sop.appealRole = partyInfo.appealRole;
        sop.lowerCourtRole = partyInfo.lowerCourtRole;
        sop.partyName = this.getPartyDisplayName(partyInfo)       
        if (partyInfo.lowerCourtRole == 'NONE (New Party)'){
            sop.conjunction = 'And';
            this.noRolePartyManualSop.push(sop);
        } else if (partyInfo.lowerCourtRole.toLowerCase() == 'plaintiff' || 
            partyInfo.lowerCourtRole.toLowerCase() == 'applicant' || 
            partyInfo.lowerCourtRole.toLowerCase() == 'petitioner'){
                sop.conjunction = 'Between';
                styleOfProceedings.manualSop.unshift(sop);
        } else {
            sop.conjunction = 'And';
            styleOfProceedings.manualSop.push(sop);
        }

        this.UpdateForm1Info(styleOfProceedings);

    }
    
    public cancelEditStyleOfProceedings() {
        this.showConfirmEditStyleOfProceeding = false;        
    }

    public saveNewStyleOfProceeding(){
        console.log('save new SOP')
        
        const msops = []
        for(const orderInx of this.form1ManualSopOrder){
            msops.push(this.styleOfProceedingsInfo.manualSop[orderInx])
        }
        this.styleOfProceedingsInfo.manualSop = msops;
        console.log(this.styleOfProceedingsInfo)


        this.UpdateForm1Info(this.styleOfProceedingsInfo);
        this.showEditStyleOfProceedingWindow = false;
    }

    public resetStyleOfProceeding(){
        console.log('reset SOP')
        this.showEditStyleOfProceedingWindow = false;
        this.styleOfProceedingsInfo.manualSop = [];
        this.UpdateForm1Info(this.styleOfProceedingsInfo);
    }

    public cancelStyleOfProceeding(){
        console.log('cancel SOP')        
        this.showEditStyleOfProceedingWindow = false;
    }

    public updateResults(){            
        this.$emit('updateResults');
    }
}
